// src/hooks/useProductPageContent.js
import { useState } from 'react';
import { getProductRecommended } from '../services/pageContentService';

const useProductRecommended = () => {
    const [status, setStatus] = useState('idle'); // idle | loading | done | error
    const [error, setError] = useState('');
    const [data, setData] = useState([]);

    const fetchProductRecommended = async () => {
        setStatus('loading');
        setError('');

        try {
            const response = await getProductRecommended();

            if (response?.status !== 'Error') {
                setData(response.data ?? response); // depending on API shape
                setStatus('done');
            } else {
                setStatus('error');
                setError(response?.message || 'Something went wrong');
            }
        } catch (err) {
            setStatus('error');
            setError(err?.message || 'Something went wrong');
        }
    };

    const resetStatus = () => {
        setStatus('idle');
        setError('');
    };

    return {
        fetchProductRecommended,
        data,
        status,
        error,
        resetStatus
    };
};

export default useProductRecommended;
